import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
  inject,
  OnChanges,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { MatDateRangeInput } from "@angular/material/datepicker";
import { DataService } from "src/app/data.service";
import { SyncService } from "src/app/sync.service";
import moment from "moment";

@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.css"],
})
export class NavbarComponent implements OnChanges {
  _dataService = inject(DataService);
  _syncService = inject(SyncService);
  @Input({ required: false }) headerText!: string;
  @Input() buttons?: { name?: string; icon?: string; function?: Function }[] =
    [];
  @Input() extraButtons?: {
    name?: string;
    icon?: string;
    function?: Function;
  }[] = [];
  @Input() ngHeader;

  @ViewChild("picker") picker;
  @ViewChild(MatDateRangeInput) dateRangeInput;
  @ViewChild("startDate") startDateInput: ElementRef;

  @Output() onChange = new EventEmitter<any>(); // for ng select changes
  items: [];
  selectedItem: number;

  showDropdown = false;

  @Input() loadingProgress: number;
  @Input() dataLoading: boolean;

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.showDropdown = window.innerWidth >= 992 && !this.isMobile();
  }

  ngOnInit() {
    this.showDropdown = window.innerWidth >= 992 && !this.isMobile();

    this.items = this.ngHeader ? this.ngHeader.items : [];
    this.selectedItem = this.ngHeader ? this.ngHeader.selectedItem : 0;
  }

  ngOnChanges() {
    if (this.dataLoading) {
      document.body.classList.add("cursorWait");
    } else {
      document.body.classList.remove("cursorWait");
    }
  }

  isMobile() {
    const mobileWidth = 768;
    return window.innerWidth < mobileWidth;
  }

  datePickerOnEnter(
    event: any,
    picker: any,
    endDateInput: any,
    startDateInput?: any
  ) {
    if (
      (event.target.value.length == 10 || event.target.value.length == 8) &&
      startDateInput
    ) {
      endDateInput.value = "";
      endDateInput.focus();
    } else {
      endDateInput.blur();
      picker.close();
    }
  }

  showButtons() {
    const buttons = document.querySelectorAll(".hidden");
    buttons.forEach((button) => {
      button.classList.toggle("hidden");
    });
  }

  hideButtons() {
    const buttons = document.querySelectorAll(".btnTopBar");
    buttons.forEach((button, index) => {
      if (index > 0) {
        button.classList.add("hidden");
      }
    });
  }

  filterDate() {
    // Only trigger the update if both dates have a value.
    if (this._dataService.startDate.value && this._dataService.endDate.value) {
      this.triggerDateUpdate();
    }
  }

  datePickerClicked(event?) {
    this.picker.open();
    setTimeout(() => {
      event.target.focus();
    });
  }

  onPickerClose() {
    const startDate = this._dataService.startDate.value;
    const endDate = this._dataService.endDate.value;

    // Check if a start date is picked but the end date is empty
    if (startDate && !endDate) {
      const today = moment();

      // Ensure the end date is not before the start date
      const newEndDate = today.isBefore(startDate) ? startDate.clone() : today;

      // Use setValue to update the existing form control
      this._dataService.endDate.setValue(newEndDate);

      this.triggerDateUpdate();
    }
  }

 private triggerDateUpdate() {
  // Save only the date values (as ISO strings) to local storage
  this._dataService.setLS("startDate", { value: this._dataService.startDate.value?.toISOString?.() });
  this._dataService.setLS("endDate", { value: this._dataService.endDate.value?.toISOString?.() });

  // Notify other parts of the application
  this._dataService.dateChanged.next(moment().startOf("month").toString());
  this._dataService.dateChangedSig.set(
    this._dataService.startDate.value.format("DD-MM-YYYY") +
      this._dataService.endDate.value.format("DD-MM-YYYY")
  );
}
}
